import { Helmet } from "react-helmet-async";

const SEO = ({
  title = "Arena - Win Rewards Through Gaming",
  description = "The ultimate gamification platform where users compete, play exciting games, and win amazing rewards. Join millions of players in the most rewarding gaming experience.",
  keywords = "gaming, rewards, gamification, competition, arena, online games, win prizes, multiplayer games",
  image = "/image/arena_image.png",
  url = "https://arenaworld.fun/",
  type = "website",
  article = false
}) => {
  const fullTitle = title.includes("Arena") ? title : `${title} | Arena`;
  const fullUrl = url.startsWith("http") ? url : `https://arenaworld.fun${url}`;
  const fullImage = image.startsWith("http") ? image : `https://arenaworld.fun${image}`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={fullUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:site_name" content="Arena" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImage} />

      {/* Article specific meta tags */}
      {article && (
        <>
          <meta property="article:publisher" content="Arena" />
          <meta property="og:type" content="article" />
        </>
      )}
    </Helmet>
  );
};

export default SEO;